"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var createTreeBuilder = function createTreeBuilder(config) {
  return function (dataList) {
    var additionalList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var parentElements = [];
    var parentIdMap = new Map();
    var rawParentIdMap = new Map();
    dataList.forEach(function (data) {
      if (typeof data !== 'object') {
        return;
      }

      var id = data[config.idField];
      var parentId = data[config.parentIdField];

      if (typeof id === 'number') {
        parentIdMap.set(id, data);

        if (typeof parentId !== 'number') {
          parentElements.push(data);
          return;
        }

        var parent = parentIdMap.get(parentId);

        if (parent) {
          if (parent[config.childsFiled] && typeof parent[config.childsFiled].length === 'number') {
            parent[config.childsFiled].push(data);
          } else {
            parent[config.childsFiled] = [data];
          }
        } else {
          rawParentIdMap.set(id, data);
        }
      }
    });
    additionalList.forEach(function (additional) {
      var parent = parentIdMap.get(additional[config.additionalParentIdField]);

      if (!parent) {
        return;
      }

      if (parent[config.additionalField] && typeof parent[config.additionalField].length === 'number') {
        parent[config.additionalField].push(additional);
      } else {
        parent[config.additionalField] = [additional];
      }
    });
    rawParentIdMap.forEach(function (data) {
      var parent = parentIdMap.get(data[config.parentIdField]);

      if (!parent) {
        return;
      }

      if (parent[config.childsFiled] && typeof parent[config.childsFiled].length === 'number') {
        parent[config.childsFiled].push(data);
      } else {
        parent[config.childsFiled] = [data];
      }
    });
    return parentElements;
  };
};

exports.createTreeBuilder = createTreeBuilder;
exports.default = createTreeBuilder;